<template>
  <section class="showroom-form">
    <embed-frame
      class="showroom-form-frame"
      endpoint="public_simulator_settings/form"
      placeholder="Carregando..."
      :settings="embedSettings"
      :callbacks="embedCallbacks"
    />
  </section>
</template>

<script>
  import EmbedFrame from '@sdk/views/Embed/Frame.vue';

  export default {
    name: 'ShowroomForm',
    components: {
      EmbedFrame,
    },
    computed: {
      embedSettings() {
        return {
          public_simulator_settings: {
            form: {
              store_id: this.$route.params.id,
            },
          },
        };
      },
      embedCallbacks() {
        return {
          'public_simulator_setting:create': this.callback,
          'public_simulator_setting:update': this.callback,
        };
      },
    },
    methods: {
      callback() {
        this.$router.push({
          name: 'stores-public-simulator-settings-list',
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .showroom-form {
    padding: 0 var(--product--pwa--horizontal);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      padding: 0 var(--product--pwa--horizontal);
    }
  }
</style>
